export const BLOCK_MAX_CHARACTERS_LENGTH = 2000;

export const BLOCK_COLORS = ['#3B82F6', '#8B5CF6', '#10B981', '#F59E0B', '#EF4444', '#EC4899', '#06B6D4', '#84CC16'];

export const PAUSE_PRESETS = [
    { duration: 0.5, label: '0.5s' },
    { duration: 1.0, label: '1s' },
    { duration: 1.5, label: '1.5s' },
    { duration: 2.0, label: '2s' },
];

// The export choices offered wherever the app lets a user export their content: audio
// with just the narration, audio with narration plus any background music track they've
// added, or a subtitle (SRT) file. `type` is passed to the download handler to say which
// one was picked; `type: 2` means "generate subtitles" rather than "download an audio
// file". Kept as one list so every export button in the app offers the same choices,
// instead of some surfaces silently missing an option (like background music) because
// their own copy of this list fell out of date.
export const EXPORT_OPTIONS = [
    { id: 'voice', label: 'Voice Only', desc: 'Download audio as MP3', type: 0 },
    { id: 'voice-music', label: 'Voice + Music', desc: 'Audio with background music', type: 1 },
    { id: 'srt', label: 'Captions (SRT)', desc: 'Download subtitle file', type: 2 },
];

export const PREVIEW_PLANS = ['preview-plan-inr-2', 'preview-plan-usd'];
export const FREE_PLANS = ['free-plan', 'free-plan-inr']
export const FREE_AND_PREVIEW_PLANS = [...PREVIEW_PLANS, ...FREE_PLANS]
export const FREE_AND_PREVIEW_DOWNLOAD_COUNT = 3
export const DEFAULT_LANG_CODE = "en-US";
export const DEFAULT_VOICE_CONFIGURATION = {
    volume: 0,
    speed: 100,
    pitch: '',
    style: '',
}

// Plans that qualify for unlimited emotional voice generations (Standard, Advanced, AppSumo)
export const UNLIMITED_EMOTIONAL_PLANS = [
    'light-plan-usd-jan-2022', 'light-plan-inr-jan-2022', 'light-plan-usd-jan-2022-annual', 'light-plan-inr-jan-2022-annual',
    'light-plan-usd-unlimited', 'light-plan-inr-unlimited', 'light-plan-usd-unlimited-annual', 'light-plan-inr-unlimited-annual',
    'full-plan', 'full-plan-inr',
    'full-plan-usd-jan-2022', 'full-plan-inr-jan-2022', 'full-plan-inr-jan-2022-annual', 'full-plan-usd-jan-2022-annual',
    'full-plan-usd-unlimited', 'full-plan-inr-unlimited', 'full-plan-usd-unlimited-annual', 'full-plan-inr-unlimited-annual',
    'listen2it_tier1', 'listen2it_tier2', 'listen2it_tier3', 'listen2it_tier4',
]